import Permissions, { usePermissions } from '@app/src/auth/permissions'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuWrapperProps } from './LegacyMenuWrapper'
import MenuWrapper from './LegacyMenuWrapper'
import type { NavbarItemProps } from './LegacyNavbarItems'

const TransparencyProductMenu: React.FC<NavbarItemProps> = ({ closeMenuDrawer }) => {
  const { formatMessage } = useIntl()
  const { hasPermission } = usePermissions()

  if (!hasPermission(Permissions.PRODUCT_MAPPING_RESPOND_ACCESS)) return null

  const menuItems: MenuWrapperProps['menuItems'] = [
    {
      title: formatMessage({ id: 'navbar.receivedMappingRequests' }),
      link: navigationLinks.mappingRequests,
      permission: [Permissions.TRANSPARENCY_USER],
    },
    {
      title: formatMessage({ id: 'navbar.companies' }),
      link: navigationLinks.productMappingCompanies,
      permission: [Permissions.TRANSPARENCY_USER],
    },
    {
      title: formatMessage({ id: 'navbar.contacts' }),
      link: navigationLinks.productMappingContacts,
    },
    {
      title: formatMessage({ id: 'navbar.allProducts' }),
      link: navigationLinks.products,
      permission: [Permissions.TRANSPARENCY_USER],
    },
  ]

  return (
    <MenuWrapper
      closeMenuDrawer={closeMenuDrawer}
      menuItems={menuItems}
      title={formatMessage({ id: 'navbar.productMapping' })}
    />
  )
}

export default TransparencyProductMenu
